import React from "react";
import { Carousel as BootstrapCarousel } from "react-bootstrap";
import "./Carousel.css";

function Carousel(props) {
  return (
    <BootstrapCarousel data-bs-theme="dark">
      {props?.bannersItems &&
        props?.bannersItems.map((item, index) => (
          <BootstrapCarousel.Item key={index}>
            <img
              className="d-block w-100 carousel-img"
              src={item.img}
              alt={item.title}
            />
            {item.title && (
              <BootstrapCarousel.Caption>
                <h5>{item.title}</h5>
                <p>{item.description}</p>
              </BootstrapCarousel.Caption>
            )}
          </BootstrapCarousel.Item>
        ))}
    </BootstrapCarousel>
  );
}

export default Carousel;
